// Xiaomi/Redmi MIUI Browser private mode ve iOS Private Browsing'de localStorage
// erişimi zaman zaman `SecurityError` fırlatır. Bu sarıcı 3 katmanlı çalışır:
//   1) localStorage (kalıcı, tercih)
//   2) sessionStorage (oturum boyunca)
//   3) in-memory Map (son çare, sayfa yenilenene kadar)
//
// Her ortamda `get/set/remove` sözleşmesi garanti çalışır — auth uçurumu yok.

const memory = new Map();

function safeCall(store, fn) {
  try {
    if (!store) return null;
    return fn(store);
  } catch {
    return null;
  }
}

function pickStore() {
  // Xiaomi/MIUI: localStorage bazen tanımlı ama write throw eder.
  try {
    const k = "__ms_probe__";
    window.localStorage.setItem(k, "1");
    window.localStorage.removeItem(k);
    return { store: window.localStorage, kind: "local" };
  } catch {}
  try {
    const k = "__ms_probe__";
    window.sessionStorage.setItem(k, "1");
    window.sessionStorage.removeItem(k);
    return { store: window.sessionStorage, kind: "session" };
  } catch {}
  return { store: null, kind: "memory" };
}

const { store, kind } = pickStore();

export const tokenStorage = {
  kind, // teşhis için: "local" | "session" | "memory"
  get(key) {
    if (store) {
      const v = safeCall(store, (s) => s.getItem(key));
      if (v != null) return v;
    }
    return memory.has(key) ? memory.get(key) : null;
  },
  set(key, value) {
    if (store) safeCall(store, (s) => s.setItem(key, value));
    memory.set(key, value);
  },
  remove(key) {
    if (store) safeCall(store, (s) => s.removeItem(key));
    memory.delete(key);
  },
};
